import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sun, Truck } from 'lucide-react';
export function FreeBonusStack() {
  const bonuses = [{
    title: 'FREE Bonus #1',
    name: 'Flat Morning Ritual Guide ($39 Value)',
    points: ['The 3 foods that trigger puffiness', 'Simple morning habits that amplify results', 'Easy lifestyle tweaks for faster comfort'],
    icon: <Sun className="w-8 h-8 text-[#10B981]" data-id="element-57" />
  }, {
    title: 'FREE Bonus #2',
    name: 'Summer Body Confidence Reset ($59 Value)',
    desc: 'Not workouts. Just the emotional and lifestyle shifts that make you feel attractive again.',
    icon: <Gift className="w-8 h-8 text-[#10B981]" data-id="element-58" />
  }, {
    title: 'FREE Bonus #3',
    name: 'Free Worldwide Shipping + Priority Processing',
    desc: 'Today only.',
    icon: <Truck className="w-8 h-8 text-[#10B981]" data-id="element-59" />
  }];
  return <section className="py-20 bg-[#F0FFF4]" data-id="element-60">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <div className="text-center mb-12" data-id="element-62">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1B5E20]" data-id="element-63">
            FREE BONUS STACK
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-64">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-md border border-[#10B981]/20" data-id="element-65">
              <div className="bg-[#F0FFF4] w-16 h-16 rounded-full flex items-center justify-center mb-4 mx-auto" data-id="element-66">
                {bonus.icon}
              </div>
              <div className="text-center" data-id="element-67">
                <p className="text-[#10B981] font-bold uppercase text-sm mb-2" data-id="element-68">
                  {bonus.title}
                </p>
                <h3 className="font-bold text-[#1B5E20] text-lg mb-4" data-id="element-69">
                  {bonus.name}
                </h3>

                {bonus.points ? <ul className="text-left space-y-2 text-sm text-[#374151]" data-id="element-70">
                    {bonus.points.map((p, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-71">
                        <span className="text-[#10B981]" data-id="element-72">•</span> {p}
                      </li>)}
                  </ul> : <p className="text-sm text-[#374151]" data-id="element-73">{bonus.desc}</p>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}